export enum IssueStatusEnum {
  REPORTED = 'reported',
  FIXED = 'fixed',
  CHECKED = 'checked',
}
